import { ContentfulClientApi, createClient, Entry, EntryCollection } from 'contentful';

import {
  ContentTypeEnum,
  getNamespaceContentType,
  Namespace
} from '@/redux/game/types';
import { ContentfulEntry } from '@/redux/pages/traitsPage/types';

type NamespaceTag = 'gaming' | 'product';

const NAMESPACE_TAG: Record<ContentTypeEnum, NamespaceTag> = {
  [ContentTypeEnum.Gaming]:  'gaming',
  [ContentTypeEnum.Product]: 'product',
  [ContentTypeEnum.Medical]: 'product',
};

export default class ContentfulApiService {
  protected namespaceTag: NamespaceTag;

  protected client: ContentfulClientApi;

  constructor(namespace: Namespace) {
    const contentType = getNamespaceContentType(namespace);
    this.namespaceTag = NAMESPACE_TAG[contentType];
    this.client = createClient({
      space:       process.env.REACT_APP_CONTENTFUL_SPACE_ID!,
      accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN!,
      environment: process.env.REACT_APP_CONTENTFUL_API_ENV,
    });
  }

  protected mapEntries = (entries: Array<Entry<ContentfulEntry>>): ContentfulEntry[] =>
    entries.map(item => item.fields);

  async getEntries(contentType: string): Promise<any> {
    const entries: EntryCollection<ContentfulEntry> = await this.client.getEntries({
      content_type: contentType,
      'metadata.tags.sys.id[in]': this.namespaceTag,
      limit: 200,
    });
    return this.mapEntries(entries.items);
  }
}
